import React, { useEffect } from 'react';
import { useIsMobile } from 'hooks/useIsMobile';
import SolicitarPermisosDesktop from './estadoCuentaDesktop/solicitarPermisosDesktop';
import SolicitarPermisosMobile from './estadoCuentaMobile/solicitarPermisosMobile';

export default function SolicitarPermisos() {
    const { isMobile } = useIsMobile();

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Bank Statement Permisson Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    return (
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ? <SolicitarPermisosDesktop/>
                    : isMobile === 'movile'
                        ? null
                        : <SolicitarPermisosMobile />
                : null
            }
        </>
    )
}